import { base64ToBlob } from './base64ToBlob';

export default { base64ToBlob }